import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import WidgetTopSectors from '../../pages/markets/component/top-sectors';

export const TopSectorsWidget = () => {
  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <WidgetTopSectors widget={true} />
    </QueryClientProvider>
  );
};
